import React, { createContext, useState, useContext, ReactNode } from "react";

interface HazardContextType {
  selectedHazard: Hazard | null;
  onHazardChange: (hazard: Hazard | null) => void;
}

const HazardContext = createContext<HazardContextType | undefined>(undefined);

export const useHazardMap = (): HazardContextType => {
  const context = useContext(HazardContext);
  if (!context) {
    throw new Error("useHazardMap must be used within a HazardProvider");
  }
  return context;
};

type HazardProviderProps = {
  children: ReactNode;
};

export const HazardProvider = ({ children }: HazardProviderProps) => {
  const [selectedHazard, setSelectedHazard] = useState<Hazard | null>(null);

  return (
    <HazardContext.Provider value={{ selectedHazard, onHazardChange: setSelectedHazard }}>
      {children}
    </HazardContext.Provider>
  );
};
